import { render, staticRenderFns } from "./TreatyPeriod.vue?vue&type=template&id=3e809e62&"
import script from "./TreatyPeriod.vue?vue&type=script&lang=js&"
export * from "./TreatyPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports